function GroupSettings() {
  return (
    <div>
      <h2>Group Settings</h2>
      <p>Your complete information comes here.</p>
    </div>
  );
}

export default GroupSettings;